var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.preparedMessage.icon.length)?_c('font-awesome-icon',{attrs:{"icon":_vm.preparedMessage.icon,"size":"lg","fixed-width":""}}):_vm._e(),_c('span',{domProps:{"innerHTML":_vm._s(_vm.preparedMessage.message)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }